module.exports = __webpack_public_path__ + "static/media/hotel-search.5b739a03.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/hotel-search.mp4
// module id = 851
// module chunks = 0